module.exports = __webpack_public_path__ + "static/img/shushi.0d138df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/shushi.png
// module id = AY2r
// module chunks = 0